import { WEB_PAGE_TYPE_V2, RECOMMENDATION_TAB_LINK_URL } from '../../constants/service/app/homeConstantsV2';

// linkUrl을 기반으로 webPageType을 결정하는 매핑 객체
export const WEB_PAGE_URL_TO_TYPE_MAPPING = {
  [RECOMMENDATION_TAB_LINK_URL]: WEB_PAGE_TYPE_V2.RECOMMENDATION_TAB,
} as const;

/**
 * linkUrl을 기반으로 webPageType을 결정하는 함수
 */
export const getWebPageTypeByUrl = (linkUrl?: string): string | undefined => {
  if (!linkUrl) return undefined;

  // linkUrl이 매핑 객체의 키를 포함하는지 확인
  const matchedKey = Object.keys(WEB_PAGE_URL_TO_TYPE_MAPPING).find((key) => linkUrl.includes(key));

  return matchedKey ? WEB_PAGE_URL_TO_TYPE_MAPPING[matchedKey as keyof typeof WEB_PAGE_URL_TO_TYPE_MAPPING] : undefined;
};
